/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { UserActivityPage } from '@/pages/UserActivity/UserActivityPage';

export function UserActivityRoute() {
  return <UserActivityPage />;
}
